import { render, staticRenderFns } from "./DialogCopiarCoordenadas.vue?vue&type=template&id=0fad7fc4&scoped=true"
import script from "./DialogCopiarCoordenadas.vue?vue&type=script&lang=js"
export * from "./DialogCopiarCoordenadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad7fc4",
  null
  
)

export default component.exports